import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    height: '100%',
    width: '100%',
    position: 'relative',
    backgroundColor: theme.colors.white,
  },
  imageContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  img: {
    flex: 1,
  },
  flex1: {
    flex: 1,
  },
  flex2: {
    flex: 2,
  },
  fill: {
    width: '100%',
    height: '100%',
  },
  exerciseArea: {
    flex: 4,
    flexDirection: 'row',
    width: '95%',
    alignSelf: 'center',
    paddingVertical: theme.spacings.sm,
    paddingHorizontal: theme.spacings.lg,
    position: 'relative',
  },
  imageWrapper: {
    flex: 1,
    height: '100%',
    maxHeight: '100%',
    aspectRatio: 1,
    alignItems: 'center',
  },
  imageInner: {
    height: '100%',
    aspectRatio: 1,
    position: 'relative',
    backgroundColor: theme.colors.white,
  },
  flex1Relative: {
    flex: 1,
    position: 'relative',
  },
  keyboardArea: {
    flex: 3,
    paddingHorizontal: theme.spacings.lg,
    justifyContent: 'center',
  },
  sentenceExerciseArea: {
    flex: 3,
    flexDirection: 'row',
    width: '95%',
    alignSelf: 'center',
    paddingVertical: theme.spacings.xs,
    paddingHorizontal: theme.spacings.lg,
  },
  flex1ItemsCenter: {
    flex: 1,
    alignItems: 'center',
  },
  videoWrapper: {
    maxHeight: 300,
    width: '100%',
    height: '100%',
    bottom: theme.spacings.xs,
  },
  keyboardAreaSentence: {
    flex: 2.5,
    justifyContent: 'center',
  },
  exerciseText: {
    fontFamily: theme.fontFamilies.exerciseFont,
  },
});
